import { z } from "zod";

export const userRoles = ["patient", "therapist", "clinic_partner", "hcp_admin", "billing_admin"] as const;
export type UserRole = (typeof userRoles)[number];

const GetUsersParamsSchema = z.object({
  email: z.string().optional(),
  id: z.string().optional(),
  limit: z.number().optional(),
  name: z.string().optional(),
  page: z.number().optional(),
  phone_number: z.string().optional(),
  uid: z.string().optional(),
  role: z.enum(userRoles).optional(),
});
export type GetUsersParams = z.infer<typeof GetUsersParamsSchema>;
